import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { hasNoStock } from "@omni/components/utils/productAvailability";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";
import { cn } from "@omni/utils/styles";
import { ReactElement } from "react";

import { Stock } from "./stock.component";

type Props = {
    productAvailability?: CloudProductAvailability;
    shopName?: string;
    className?: string;
};

const ItemStock = ({
    productAvailability,
    shopName,
    className
}: Props): ReactElement => {
    const { t } = useGranite();

    const isOufOfStock = hasNoStock(
        productAvailability?.realTimeStockAvailable,
        productAvailability?.stockLevel,
        productAvailability?.realTimeStock
    );

    return (
        <div
            className={cn("tw:mb-2", className)}
            style={{
                opacity:
                    productAvailability?.stockLevel ===
                        CloudStockLevel.NoStock ||
                    productAvailability?.stockLevel ===
                        CloudStockLevel.UnknownStock
                        ? "0.5"
                        : "1"
            }}
        >
            {shopName && (
                <div className={cn("tw:text-sm tw:font-bold")}>
                    {isOufOfStock
                        ? t(
                              "pdp.deliveryPromise.noStock.driveInPickUp",
                              shopName
                          )
                        : t(
                              "ecommerce.label.pickup.preferredStore.driveIn",
                              shopName
                          )}
                </div>
            )}
            <div className={cn("tw:text-sm")}>
                <Stock productAvailability={productAvailability} />
            </div>
        </div>
    );
};

export { ItemStock };
